import img1 from "../Image/coding.png";
import img2 from "../Image/web_development.png";
import img3 from "../Image/frontend.png";
import img4 from "../Image/chat.png";
import img5 from "../Image/backend.png";
import img6 from "../Image/starategy.png";
const data = [
  {
    id: 1,
    // image: "https://www.flaticon.com/free-icons/coding",
    image: img1,
    title: "Problem Solver",
    desc: "I'm a skilled problem solver, finding creative solutions to challenges with expertise and dedication. Bringing clarity and innovation to every task.",
  },
  {
    id: 2,
    // image:"https://www.flaticon.com/free-icons/web-development",
    image: img2,  
    title: "Data Analyst",
    desc: "I developed an interactive dashboard for real-time data analysis, enabling businesses to uncover insights quickly. It's efficient, intuitive, and enhances decision-making with ease.",
  },
  {
    id: 3,
    // image: "https://www.flaticon.com/free-icons/strategy",
    image: img6,
    title: "Business Analyst",
    desc: "Developed a communication analysis system to evaluate user interactions and engagement. Enabled efficient data-driven insights to enhance connectivity and streamline communication processes.",
  },
  {
    id: 4,
    // image: "https://img.icons8.com/material-outlined/64/000000/topic--v1.png",
    image: img4,
    title: "Web Development",
    desc: "Proficient full-stack developer with expertise in front-end and back-end technologies, creating seamless web applications for optimal user experiences",
  },

  {
    id: 5,
    // image: "https://www.flaticon.com/free-icons/ux",
    image: img3,
    title: "Frontend Development",
    desc: "Experienced frontend programmer skilled in crafting interactive, responsive, and user-friendly web interfaces with proficiency in HTML, CSS, JavaScript, and frameworks.",
  },
 
  {
    id: 6,
    // image: "https://www.flaticon.com/free-icons/backend",
    image: img5,
    title: "Backend Development",
    desc: "Experienced backend programmer adept in building scalable, efficient, and secure systems to power applications, with a passion for optimizing performance.",
  },
 
];
export default data;
